import * as React from 'react';
import styled from 'styled-components';
import { SemanticUI } from '@iterable/deprecated_react_components';
import { ASCENDING, DESCENDING } from 'constants/sortDirections';

const HeaderCell = styled.div`
  color: ${({ isActiveSort }) => (isActiveSort ? '#333' : '#717171')};
  display: table-cell;
  font-size: 13px;
  font-weight: ${({ isActiveSort }) => (isActiveSort ? 'bold' : '400')};
  padding: 15px;
  text-align: ${(props) => props.align};
  white-space: nowrap;
`;

// type Props = {
//   columnData: {
//     align: 'left' | 'center' | 'right',
//     name: string,
//   },
//   isActiveSort: Boolean,
//   handleClick: () => {},
//   sortable?: Boolean,
//   sortDirection: SortDirections,
//   children: React.Node,
// };

export const TableHeaderCell = ({
  columnData,
  handleClick,
  isActiveSort,
  sortable = false,
  sortDirection,
  children,
}) => {
  let iconName = 'sort';
  if (isActiveSort) {
    if (sortDirection === ASCENDING) {
      iconName = 'sort up';
    }
    if (sortDirection === DESCENDING) {
      iconName = 'sort down';
    }
  }

  return (
    <HeaderCell
      align={columnData.align}
      data-test="header-cell"
      isActiveSort={isActiveSort}
      onClick={handleClick}
      role="columnheader"
    >
      {children || (
        <React.Fragment>
          {columnData.name}
          {sortable && <SemanticUI.Icon data-test="header-cell-sort-icon" name={iconName} />}
        </React.Fragment>
      )}
    </HeaderCell>
  );
};
